import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.element.addEventListener("pointerdown", this.preserveInputFocus)
    this.inputTarget.addEventListener("input", this.rememberSelection)
    this.inputTarget.addEventListener("keyup", this.rememberSelection)
    this.inputTarget.addEventListener("pointerup", this.rememberSelection)
    this.inputTarget.addEventListener("select", this.rememberSelection)
  }

  disconnect() {
    this.element.removeEventListener("pointerdown", this.preserveInputFocus)
    this.inputTarget.removeEventListener("input", this.rememberSelection)
    this.inputTarget.removeEventListener("keyup", this.rememberSelection)
    this.inputTarget.removeEventListener("pointerup", this.rememberSelection)
    this.inputTarget.removeEventListener("select", this.rememberSelection)
  }

  rememberSelection = (event) => {
    if (this.isInserting && (event.type === "input" || event.isTrusted)) return

    this.selectionStart = this.inputTarget.selectionStart
    this.selectionEnd = this.inputTarget.selectionEnd
    this.lastInsertPosition = null
  }

  preserveInputFocus = (event) => {
    if (event.target.closest("[data-insert-text-value-param]")) {
      event.preventDefault()
    }
  }

  insert(event) {
    const text = event.params.value
    const input = this.inputTarget
    const hasRememberedSelection = Number.isInteger(this.selectionStart) && Number.isInteger(this.selectionEnd)
    const useLastInsertPosition = Number.isInteger(this.lastInsertPosition) &&
      input.selectionStart === 0 &&
      input.selectionEnd === 0
    const useCurrentSelection = document.activeElement === input && hasRememberedSelection && !useLastInsertPosition
    const start = this.insertStart(input, useLastInsertPosition, useCurrentSelection)
    const end = this.insertEnd(input, useLastInsertPosition, useCurrentSelection)
    const cursorPosition = start + text.length

    input.value = `${input.value.slice(0, start)}${text}${input.value.slice(end)}`
    input.focus()
    input.selectionStart = cursorPosition
    input.selectionEnd = cursorPosition
    this.selectionStart = cursorPosition
    this.selectionEnd = cursorPosition
    this.lastInsertPosition = cursorPosition
    this.isInserting = true
    input.dispatchEvent(new Event("input", { bubbles: true }))
    setTimeout(() => {
      this.isInserting = false
    }, 0)
  }

  replace(event) {
    const text = event.params.value
    const input = this.inputTarget
    const cursorPosition = text.length

    input.value = text
    input.focus()
    input.selectionStart = cursorPosition
    input.selectionEnd = cursorPosition
    this.selectionStart = cursorPosition
    this.selectionEnd = cursorPosition
    this.lastInsertPosition = cursorPosition
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }

  insertStart(input, useLastInsertPosition, useCurrentSelection) {
    if (useLastInsertPosition) return this.lastInsertPosition
    if (useCurrentSelection) return this.selectionStart

    return input.value.length
  }

  insertEnd(input, useLastInsertPosition, useCurrentSelection) {
    if (useLastInsertPosition) return this.lastInsertPosition
    if (useCurrentSelection) return this.selectionEnd

    return input.value.length
  }
}
